import ActionButtonData from 'txp-data/lib/schema/viewSchema/ActionButtonData';
import TailoredActionName from 'owa-txp/lib/store/schema/telemetry/TailoredActionName';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import shouldShowEditButton from './shouldShowEditButton';
import owaLocalizedStrings from 'owa-strings/owa-txp-strings';
import CardItem from 'txp-data/lib/schema/viewSchema/CardItem';

export default function getEditableActionButtonProps(
    txpConfiguration: TxpConfiguration,
    cardItem: CardItem
): ActionButtonData {
    if (shouldShowEditButton(txpConfiguration, cardItem)) {
        return {
            actionButtonText: owaLocalizedStrings.editEventText,
            actionIconName:
                txpConfiguration.txpImages && txpConfiguration.txpImages.detailsIcons
                    ? txpConfiguration.txpImages.detailsIcons.edit
                    : null,
            actionName: TailoredActionName.EditCard,
            showSpinner: !txpConfiguration.isButtonEnabled,
        };
    }

    return null;
}
